import React, { memo, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { updateQueryString as updateQueryStringAction } from 'services/router/actions';
import { makeSelectQueryStringBooleanValue } from 'workspaces/react-router-selectors';
// @ts-ignore
import { selectMultipleActiveTableRowsExist } from 'services/selectedTableCells/selectors';

import VirtualizedTableBulkEditFormWrapper from '../VirtualizedTableBulkEditFormWrapper';
import { BULK_EDIT_MODAL_QUERY_STRING_PARAM } from '../../constants';

interface ConnectedProps {
    isOpen?: boolean;
    multipleActiveTableRowsExist?: boolean;
}

interface DispatchProps {
    updateQueryString: typeof updateQueryStringAction;
}

type Props = ConnectedProps & DispatchProps;

export const VirtualizedTableBulkEditModalComponent = (
    props: Props
): React.ReactElement => {
    const { isOpen, multipleActiveTableRowsExist, updateQueryString } = props;

    const handleClose = useCallback((): void => {
        updateQueryString({
            [BULK_EDIT_MODAL_QUERY_STRING_PARAM]: undefined
        });
    }, [updateQueryString]);

    useEffect(() => {
        if (isOpen && !multipleActiveTableRowsExist) {
            handleClose();
        }
    }, [isOpen, multipleActiveTableRowsExist, handleClose]);

    return (
        <Modal
            size="tiny"
            open={isOpen}
            centered={false}
            onClose={handleClose}
            closeIcon
        >
            <Modal.Header>Replace Value</Modal.Header>
            <Modal.Content>
                <VirtualizedTableBulkEditFormWrapper onClose={handleClose} />
            </Modal.Content>
        </Modal>
    );
};

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    isOpen: makeSelectQueryStringBooleanValue(
        BULK_EDIT_MODAL_QUERY_STRING_PARAM
    ),
    multipleActiveTableRowsExist: selectMultipleActiveTableRowsExist
});

export default connect(
    mapStateToProps,
    {
        updateQueryString: updateQueryStringAction
    }
)(memo(VirtualizedTableBulkEditModalComponent));
